import { Loading03Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const spinnerVariants = cva('animate-spin', {
  variants: {
    size: {
      sm: 'size-3',
      default: 'size-4',
      lg: 'size-6',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

/** Só mostra o spinner depois de `atrasoMs`; cargas rápidas não piscam na tela. */
function useAtraso(atrasoMs: number): boolean {
  const [pronto, setPronto] = React.useState(atrasoMs <= 0)
  React.useEffect(() => {
    if (atrasoMs <= 0) return
    const t = window.setTimeout(() => setPronto(true), atrasoMs)
    return () => window.clearTimeout(t)
  }, [atrasoMs])
  return pronto
}

function Spinner({
  className,
  size,
  atrasoMs = 0,
  ...props
}: Omit<React.ComponentProps<'svg'>, 'strokeWidth'> &
  VariantProps<typeof spinnerVariants> & {
    /** Espera antes de aparecer. Padrão 0 (aparece na hora). */
    atrasoMs?: number
  }) {
  const visivel = useAtraso(atrasoMs)
  if (!visivel) return null
  return (
    <HugeiconsIcon
      icon={Loading03Icon}
      strokeWidth={2}
      data-slot="spinner"
      role="status"
      aria-label="Carregando"
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  )
}

/** Spinner com texto, que só aparece depois de 500 ms (carregamentos de página). */
function Carregando({
  texto = 'Carregando...',
  atrasoMs = 500,
}: {
  texto?: string
  atrasoMs?: number
}) {
  const visivel = useAtraso(atrasoMs)
  if (!visivel) return null
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground" role="status">
      <Spinner />
      <span>{texto}</span>
    </div>
  )
}

export { Carregando, Spinner }
